import React from "react";
import AccrualGenericSkeleton from "./AccrualGenericSkeleton";

function AccrualDetailSkeleton() {
  return (
    <>
      <AccrualGenericSkeleton />
    </>
  );
}

export default AccrualDetailSkeleton;
